module.exports = "/build/web/images/partners/kkd.d8ea050d6dcd28adcc8a2188312c199e.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/kkd.png
// module id = 130
// module chunks = 24